import React from 'react';
import Dialog from '@mui/material/Dialog';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingModal = (props: { open: boolean }) => {
  const { open } = props;
  return (
    <Dialog hideBackdrop={true} open={open}>
      <Backdrop invisible={true} open={true}>
        <CircularProgress color="primary" />
      </Backdrop>
    </Dialog>
  );
};

export default LoadingModal;
